import { ReactNode } from "react"

export interface ShowProps {
  when: unknown
  children: ReactNode
  fallback?: ReactNode
}

const Show = ({ when, children, fallback }: ShowProps): JSX.Element =>
  (when ? children : fallback ?? null) as JSX.Element

export default Show
